import img from "../../assets/img/home4/History  image 767 x 858.jpg";
import CorporateData from "./CorporateData";

const CorporateFaq = () => {
  return (
    <>

<section className="we-work-skill-wrapper section-padding" style={{
        paddingBottom:"20px"
    }}>
        <div className="container">
        {/* <div className="row">
            <div className="col-xl-6 col-lg-8 mb-4 offset-xl-3 offset-lg-2 col-12 text-lg-center">
                <div className="section-title-4">
                    <h2>We Work For Brands And 
                        Show Creativity
                    </h2>
                </div>
            </div>
        </div> */}
        <div className="row">
            <div className="col-md-12 col-xl-12 mt-lg-12">
            <div className="our-achievement-skill-wrapper">
                <ul>
                    <li>Our Presence Across the Value Chain </li>
                    
                    
                </ul>
                <p className="border-left">The world is evolving rapidly, and to sustain long-term success, we must anticipate industry trends, adapt to changing market dynamics, and take proactive steps toward the future. Our 2020 Vision serves as a strategic blueprint, outlining our path forward and ensuring that we continue to grow alongside our stakeholders and partners.  </p>
                
                         
                    </div>
                </div>
               
            </div>
        </div>
    </section>

    <section
      className="faq-ask-wrapper"
      style={{
        paddingTop: "200px",
      }}
    >
      <div className="container">
        <div className="row">
          {/* <div className="col-xl-5 col-12">
                       <div className="call-phone-cta">
                             
                            <div className="content">
                                
                                <h2>Milestones in Our Growth</h2>
                            </div> 
                        </div> 
                        <div className="faq-img mt-20">
                            <img src={img} alt="" />
                        </div>
                    </div> */}
          <div className="col-xl-12 col-12 mt-5 mt-xl-0">
            <div className="faq-question-wrapper corporateFAQ">
              <div className="faq-content">
                {/* <h2>Milestones in Our Growth </h2> */}
                <div className="faq-ask-list mtm-20">
                  <div className="accordion" id="accordion">
                    {CorporateData.map((data) => (
                      <div className="accordion-item" key={data.id}>
                        <h4 className="accordion-header">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#${data.index}`}
                            aria-expanded="false"
                            aria-controls={data.index}
                          >
                            {data.ques}
                          </button>
                        </h4>
                        <div
                          id={data.index}
                          className="accordion-collapse collapse"
                          data-bs-parent="#accordion"
                        >
                          <div className="accordion-body">
                            <p>{data.ans}</p>
                            <p>{data.miniDescription}</p>
                            {(data.ponitone?.trim() ||
                              "" ||
                              data.ponittwo?.trim() ||
                              "" ||
                              data.ponitthree?.trim() ||
                              "" ||
                              data.ponitfour?.trim() ||
                              "" ||
                              data.ponitfive?.trim() ||
                              "" ||
                              data.ponitsix?.trim() ||
                              "") && (
                              <div className="checked-features-list style-2">
                                <ul>
                                  {data.ponitone?.trim() && (
                                    <li>{data.ponitone}</li>
                                  )}
                                  {data.ponittwo?.trim() && (
                                    <li>{data.ponittwo}</li>
                                  )}
                                  {data.ponitthree?.trim() && (
                                    <li>{data.ponitthree}</li>
                                  )}
                                  {data.ponitfour?.trim() && (
                                    <li>{data.ponitfour}</li>
                                  )}
                                  {data.ponitfive?.trim() && (
                                    <li>{data.ponitfive}</li>
                                  )}
                                  {data.ponitsix?.trim() && (
                                    <li>{data.ponitsix}</li>
                                  )}
                                </ul>
                              </div>
                            )}

                            <p>{data.smalldes}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default CorporateFaq;
